<template>
  <div class="search-content">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
  export default {
    name: 'SettingLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '赛事申请'
            },
            {
              key: '2',
              title: '赛事筹备'
            },
            {
              key: '3',
              title: '筹备计划模版'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/sai/SaiquApplyList':
                return '1'
              case '/sai/SaiquDataList':
                return '2'
              case '/sai/SaiDateTplDetail':
                return '3'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/sai/SaiquApplyList')
                break
              case '2':
                this.$router.push('/sai/SaiquDataList')
                break
              case '3':
                this.$router.push('/sai/SaiDateTplDetail')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
